import * as R from "ramda";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import * as English from "../constants/i18n/en";
import * as Spanish from "../constants/i18n/es";

dayjs.extend(isSameOrBefore);

const languages = {
  ES: Spanish,
  EN: English,
};

export const UpcomingOrMonthYear = (date) => {
  const then = dayjs(date);
  return then.isSameOrBefore(dayjs()) ? then.format("MMMM, YYYY") : "";
};

export const Translate = (lang, path) => {
  return R.path([lang, ...path], languages);
};
